import { Component } from 'preact';
import React from 'react';
import PhoneInput from 'react-phone-input-2';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Text from '../../Global/Text';
import { actionHandler } from '../../../utilities/form/formUtils';


class TelephoneInput extends Component {
  render() {
    const {
      id,
      label,
      columns,
      type,
      className,
      placeholder,
      countryCodeEditable,
      autocompleteSearch,
      country,
      setValues,
      values,
      setFieldValue,
      inputProps,
      dispatch,
      actions,
    } = this.props;

    const formFieldClass = classNames(
      'form__field', {
        [`form__field--${id}`]: id,
        [`form__field--${type}`]: type,
        [`form__field--${columns}col`]: columns,
        [`${className}`]: className !== '',
      }
    );
    const handleOnChange = (value, data, event, formattedValue) => {
      const name = `${[id]}Text`;
      const maxLength = data.countryCode === 'dk' ? 10 : 8;
      if (typeof value === 'string' && value.length >= maxLength) {
        setFieldValue(id, value);
        setFieldValue(name, value);
      } else {
        setFieldValue(id, '');
        setFieldValue(name, '');
      }

      actionHandler(actions, null, null, dispatch, values, setValues);
    };
    return (

      <div className={formFieldClass} >
        <Text
          value={label}
          component = "label"
          htmlFor={id}
        />
        <PhoneInput
          inputProps={inputProps}
          country={country}
          countryCodeEditable={countryCodeEditable}
          autocompleteSearch={autocompleteSearch}
          onChange={ handleOnChange }
          placeholder={placeholder}
        />
      </div>
    );
  }
}

export default TelephoneInput;

TelephoneInput.defaultProps = {
  id: '',
  label: '',
  columns: '3',
  type: '',
  className: '',
  placeholder: '',
};
TelephoneInput.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.string,
  label: PropTypes.string,
  columns: PropTypes.string,
  placeholder: PropTypes.string,
  autocompleteSearch: PropTypes.bool.isRequired,
  countryCodeEditable: PropTypes.bool.isRequired,
  country: PropTypes.string.isRequired,
  setValues: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  inputProps: PropTypes.object.isRequired,
  actions: PropTypes.array,

};